import beyondTlBlockA from "../../../assets/report/beyondxlh/1.png";
import beyondTlBlockB from "../../../assets/report/beyondxlh/2.png";
import beyondBrBlockA from "../../../assets/report/beyondxlh/3.png";
import beyondBrBlockB from "../../../assets/report/beyondxlh/4.png";
import tlCircle from "../../../assets/report/ultragenyx/circle-l-top.png";
import brCircle from "../../../assets/report/ultragenyx/circle-r-bottom.png";
import tlStripes from "../../../assets/report/ultragenyx/stripes-l-top.png";
import brStripes from "../../../assets/report/ultragenyx/stripes-r-bottom.png";
import beyondLogo from "../../../assets/report/beyondxlh/beyondxlh_logo.png";
import logo from "../../../assets/logo.png";
import { themes } from "../../../modules/theme";

export const reportThemes = {
  beyondxlh: {
    primary: "#41a53b",
    secondary: "#1d4e49",
    tlBlockA: beyondTlBlockA,
    tlBlockB: beyondTlBlockB,
    brBlockA: beyondBrBlockA,
    brBlockB: beyondBrBlockB,
    logo: beyondLogo,
    showCompletion: false,
    tableBorder: themes.glacierWhite,
    tableRowsBackgroundColor: themes.glacierWhite,
  },
  rarify: {
    primary: "#a0248d",
    secondary: "#942a8e",
    tlBlockA: tlStripes,
    tlBlockB: tlCircle,
    brBlockA: brCircle,
    brBlockB: brStripes,
    logo: logo,
    showCompletion: true,
    tableBorder: themes.default.glacierWhite,
    tableRowsBackgroundColor: themes.default.glacierWhite,
  },
};
